<template>
	<svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
	    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	        <g transform="translate(1.000000, 1.000000)" stroke="#979797">
	            <path d="M4.5,9 C6.98528137,9 9,6.98528137 9,4.5 C9,3.41340016 8.61487426,2.41675126 7.97367735,1.63910786 C7.14832265,0.638117943 5.89868154,0 4.5,0 C2.01471863,0 0,2.01471863 0,4.5 C0,6.98528137 2.01471863,9 4.5,9 Z"></path>
	            <polyline points="7.41625 7.41625 10.2134675 10.2134675 11.66625 11.66625"></polyline>
	        </g>
	    </g>
	</svg>
</template>
<script>
export default { name: 'navbar-search-icon' }
</script>
